import { useState } from "react"
import { message } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"



export const ModalConfirmDelete = ({onCancel, onDelete, selectedRowKeys}) => {
    const [isLoading, setIsLoading] = useState(false);
    
    const handleDelete = async () => {
        setIsLoading(true);
        try {
           await onDelete();
        } catch (error) {
            message.error("Có lỗi xảy ra!")
            console.log("handleSave error", error)
        }finally {
            setIsLoading(false)
        }
    }

    return <>
    <div className="d-flex" style={{gap: '12px'}}>
        <div><SvgIcon name="warning-import" /></div>
        <div>
            <p>Bạn có chắc chắn muốn xóa <span style={{fontWeight: "700"}}>"{selectedRowKeys.length} Liên hệ"</span> không !</p>
            <p>Hành động này không thể hoàn tác.</p>
        </div>
    </div>
    <div className="d-flex justify-content-flex-end pt-10">
              <Button
                btnType="back"
                className="btn-hover-shadow mr-15"
                onClick={onCancel}
              >
                Hủy bỏ
              </Button>
              <Button
                btnType="primary"
                className="btn-hover-shadow"
                onClick={handleDelete}
              >
                {isLoading ? <LoadingOutlined /> : "Xoá"}
              </Button>
            </div>
    </>
}